import React, { JSX } from 'react'
import { clsx } from 'clsx'
import { classToFComponent, type FCClassContext, ViewSlot } from 'cube-react'
import { Col, Container, Row, BrFooter } from '@govbr-ds/react-components'

import Header from './v-header'
import Menu from './v-menu'
import DialogView from './v-dialog'
import AlertView from './v-alert'

import { MainScope } from '../main.scope'

export type MainViewProps = {
    className?: string
    scope: MainScope
}

class MainViewClass implements FCClassContext<MainViewProps> {
    fluid = true
    scope!: MainScope

    render({ className, scope }: MainViewProps) {
        this.scope = scope

        let dialogElm: JSX.Element = undefined
        if (scope.dialog) {
            dialogElm = <DialogView scope={scope.dialog} />
        }

        let alertElm: JSX.Element = undefined
        if (scope.alert) {
            alertElm = <AlertView scope={scope.alert} />
        }

        return (
            <div className={clsx(className)}>
                <Header fluid={this.fluid} scope={scope.header} />
                <Container fluid={this.fluid} margin={{ t: 3, b: 6 }}>
                    <Row>
                        <Menu scope={scope.menu} />
                        <Col>
                            <ViewSlot scope={scope.page} />
                        </Col>
                    </Row>
                </Container>

                {/* Footer Customizado para remover logo do governo e usar identidade Lifeshub */}
                <BrFooter
                    userLicenseText={
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            BulaCerta AI - Uma solução <strong>Lifeshub Group SA</strong>
                            <br />
                            <span style={{ fontSize: '0.8em' }}>
                                Dados baseados em regulações da ANVISA - Atualizado diariamente.
                            </span>
                        </div>
                    }
                />
                {dialogElm}
                {alertElm}
            </div>
        )
    }
}

export default classToFComponent<MainViewProps>(MainViewClass)
